import { render, staticRenderFns } from "./FrequencyView.vue?vue&type=template&id=248569f6"
import script from "./FrequencyView.vue?vue&type=script&lang=js"
export * from "./FrequencyView.vue?vue&type=script&lang=js"
import style0 from "./FrequencyView.vue?vue&type=style&index=0&id=248569f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports